import { RecoilState, useSetRecoilState } from "recoil";

export function buildUseSetRecoilState<T>(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  input: RecoilState<T>
) {
  return function useSetState() {
    return useSetRecoilState(input);
  };
}
